import a from "react";
import { useTranslation as n } from "react-i18next";
import c from "../../../hooks/customization/useCustomization.js";
import m from "../OrderButton/orderButton.module.scss.js";
function h(o) {
  const {
    restaurant: l
  } = o, { t: r } = n(), {
    configuration: t,
    getTextTranslations: s
  } = c(), e = s("popup");
  return /* @__PURE__ */ a.createElement(
    "a",
    {
      "data-testid": "call-button",
      href: `tel:${l.phone}`,
      className: m.button,
      style: {
        backgroundColor: t == null ? void 0 : t.design.colors.general.highlightBackground,
        color: t == null ? void 0 : t.design.colors.general.highlightText
      }
    },
    (e == null ? void 0 : e.call) || r("call")
  );
}
export {
  h as CallButton
};
//# sourceMappingURL=CallButton.js.map
